import { Outlet, useParams } from '@tanstack/react-router';
import { CurrentMatterProvider } from '@/components/contexts/CurrentMatterContext';
import useMatter from '@/hooks/useMatter';
import Loading from './Loading';
import NoAccessToCase from './NoAccessToCase';

/**
 * Route guard for everything under `/matter/$slug`. Mounts once when a matter is
 * entered and renders child pages through <Outlet/> only when the user has
 * access, so pages no longer need to opt in individually.
 */
export default function MatterAccessGuard() {
  const { slug: matterGuid } = useParams({ from: '/matter/$slug' });
  const { matter, isLoading, isError, mutateMatter } = useMatter(matterGuid);

  if (isLoading) {
    return <Loading />;
  }

  if (isError || !matter) {
    return <NoAccessToCase matterExists={false} />;
  }

  if (matter.permissions.length === 0) {
    return (
      <NoAccessToCase
        matterExists
        matterGuid={matter.guid}
        matterName={matter.name}
        onJoined={mutateMatter}
      />
    );
  }

  return (
    <CurrentMatterProvider value={{ matter, mutate: mutateMatter }}>
      <Outlet />
    </CurrentMatterProvider>
  );
}
